import React from 'react';
import { Modal, ModalHeader } from 'reactstrap';
import ReviewEvidenceForm from '../../Forms/Evidence/ReviewEvidenceForm';

const ReviewEvidenceModal = ({ data, dataEvidence, isOpen, handleToggleModal, showDetails}) => {
	return (
		<div>
			<Modal
				isOpen={isOpen}
				toggle={() => handleToggleModal()}
				size='lg'
				className='border-0'
				modalClassName='modal fade zoomIn'
				backdrop={'static'}
				centered={true}
			>
				<ModalHeader toggle={handleToggleModal}>Revisar Evidencia</ModalHeader>
				<div className='mt-2'>
					<ReviewEvidenceForm
						isOpen={isOpen}
						data={data}
                        dataEvidence={dataEvidence}
						handleToggleModal={handleToggleModal}
						showDetails={showDetails}
					/>
				</div>
			</Modal>
		</div>
	);
};

export default ReviewEvidenceModal;